<template>
  <div :class="daisy_ui_styling ? 'flex items-center mt-1' : 'd-flex align-items-center'">
    <div class="px-1" v-if="show_play_actions">
      <a :title="play_button_title" href="" @click.prevent="toggle_play()">
        <div v-if="daisy_ui_styling" class="text-primary">
          <span v-if="!is_playing">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
            </svg>
          </span>
          <span v-if="is_playing">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
            </svg>
          </span>
        </div>
        <div v-else>
          <span v-if="!is_playing" class="mdi mdi-play font-18 text-warning"></span>
          <span v-if="is_playing" class="mdi mdi-pause font-18 text-warning"></span>
        </div>
      </a>
    </div>

    <div :class="daisy_ui_styling ? 'flex-1 px-1' : 'flex-grow-1 px-1'">
      <progress ref="progress_bar_container" v-if="daisy_ui_styling" @click="on_seek($event)" class="progress progress-primary w-full" :value="current_time" :max="media_duration"></progress>
      <div v-else @click="on_seek($event)" ref="progress_bar_container" class="progress" style="height: 10px;">
        <div class="progress-bar bg-primary" role="progressbar" :aria-valuenow="current_time" aria-valuemin="0" :aria-valuemax="media_duration" :style="style"></div>
      </div>
    </div>

    <div class="px-1">
      <p style="margin: 0">{{ time_display }}</p>
    </div>
    <div class="px-1" v-if="show_full_screen_options && !daisy_ui_styling">
      <a href="" :title="fs_button_title" @click.prevent="toggle_full_screen">
        <span v-if="is_full_screen" class="mdi mdi-arrow-collapse font-18 text-secondary"></span>
        <span v-if="!is_full_screen" class="mdi mdi-arrow-expand font-18 text-secondary"></span>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      daisy_ui_styling: {
        type: Boolean,
        required: false,
        default: false
      },
      media_duration: {
        type: Number,
        required: true
      },
      current_time: {
        type: Number,
        required: true
      },
      progress_percentage: {
        type: Number,
        required: false
      },
      show_play_actions: {
        type: Boolean,
        required: true
      },
      is_playing: {
        type: Boolean,
        required: false
      },
      show_full_screen_options:{
        type: Boolean,
        required: true,
      },
      is_full_screen: {
        type: Boolean,
        required: false
      }
    },
    computed: {
      style: function(){
        if (!this.media_duration) return '';
        const percentage = this.progress_percentage || (this.current_time / this.media_duration) * 100;

        return `width: ${percentage}%;`
      },
      time_display: function(){
        const time_in_seconds = parseInt(this.current_time)
        const seconds = time_in_seconds % 60
        const minutes = parseInt(time_in_seconds / 60) % 60
        const hours = parseInt(time_in_seconds / 3600)

        return `${hours ? `${hours}:` : ''}${ hours && minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
      },
      play_button_title: function(){
        return this.is_playing ? this.$t('embodia_player.pause') : this.$t('embodia_player.play')
      },
      fs_button_title: function(){
        return this.is_full_screen ? this.$t('embodia_player.exit_full_screen') : this.$t('embodia_player.full_screen')
      }
    },
    methods: {
      on_seek: function(event){
        // https://www.w3schools.com/jsref/event_which.asp
        //Left mouse button
        if (event.which === 1) {
          const bounds = this.$refs['progress_bar_container'].getBoundingClientRect();
          let current_time = (event.clientX - bounds.x) / bounds.width * this.media_duration;

          if (current_time < 0) {
            current_time = 0
          }else if (current_time > this.media_duration){
            current_time = this.media_duration
          }

          this.$emit('set_current_time', current_time)
        }
      },
      toggle_play: function(){
        this.$emit('on_play_toggle')
      },
      toggle_full_screen: function(){
        this.$emit('on_full_screen_toggle');
      }
    }
  }
</script>